import { createFileRoute } from '@tanstack/react-router';
import { SuccessStep } from './-components/project-new-steps/success-step';

export const Route = createFileRoute('/ngos/projects/new/success')({
	component: SuccessStep,
});
